import { render, staticRenderFns } from "./AllInvestmentsReceivablesTable.vue?vue&type=template&id=694bd05e&"
import script from "./AllInvestmentsReceivablesTable.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports